/**
 * Public branding API.
 */

import { getApiV1BaseUrlFromEnv } from '@/lib/apiBaseUrl';
import type { CompleteBrandingResponse } from '@/types/branding.types';

/** Fallback company UUID when VITE_COMPANY_ID is unset. */
const DEFAULT_BRANDING_COMPANY_ID = '354eb5d0-17a4-4906-8b27-7c6339bdcd70';

/** Company UUID used by `GET /public/branding/:companyId`. */
function resolveBrandingCompanyId(): string {
  return import.meta.env.VITE_COMPANY_ID || DEFAULT_BRANDING_COMPANY_ID;
}

/**
 * `GET /public/branding/:companyId` — unauthenticated.
 * Uses raw `fetch` so axios auth / company-rewrite interceptors do not run.
 */
export async function getPublicBranding(
  companyId: string = resolveBrandingCompanyId(),
): Promise<CompleteBrandingResponse> {
  const base = getApiV1BaseUrlFromEnv(import.meta.env.VITE_API_URL);
  const response = await fetch(`${base}/public/branding/${companyId}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`Failed to load branding: ${response.statusText}`);
  }

  return (await response.json()) as CompleteBrandingResponse;
}
